import React from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

import { intlShape } from 'common/components/intl/intlShape';
import { TranslatedMessage, translateMessage } from 'common/components/Intl';

// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as f from 'common/components/Form';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as m from '../../messages';
import PropTypes from '../../propTypes';

// A glorified link to the Jumio Netverify scans controller.
//
// This is a form which submits with the GET method
// we require opt-in for facial recognition in some countries.
export class JumioStartForm extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    netVerifyUrl: PropTypes.string.isRequired,
    idUploadAffirmationRequired: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      hasOptInt: false,
      isSubmitting: false,
    };
  }

  formInvalid() {
    return this.jumioOptinRequired() && !this.state.hasOptInt;
  }

  handleSubmit() {
    this.setState({ isSubmitting: true });
  }

  onChangeOptIn() {
    this.setState({
      hasOptInt: !this.state.hasOptInt,
    });
  }

  JumioPrivacyPolicyLink() {
    const { intl } = this.props;
    const jumioLinkText = translateMessage(
      intl,
      m.LABEL_JUMIO_OPTIN_PRIVACY_POLICY_LINK_TEXT
    );
    const jumioLinkUrl = translateMessage(
      intl,
      m.LABEL_JUMIO_OPTIN_PRIVACY_POLICY_LINK_URL
    );
    return <a href={jumioLinkUrl}>{jumioLinkText}</a>;
  }

  JumioTOSLink() {
    const { intl } = this.props;
    const jumioLinkText = translateMessage(
      intl,
      m.LABEL_JUMIO_OPTIN_TOS_LINK_TEXT
    );
    const jumioLinkUrl = translateMessage(
      intl,
      m.LABEL_JUMIO_OPTIN_TOS_LINK_URL
    );
    return <a href={jumioLinkUrl}>{jumioLinkText}</a>;
  }

  jumioOptinRequired() {
    return this.props.idUploadAffirmationRequired;
  }

  render() {
    return (
      <form
        method="GET"
        action={this.props.netVerifyUrl}
        onSubmit={this.handleSubmit.bind(this)}
      >
        {this.jumioOptinRequired() && (
          <p className="Field--checkbox" style={{ paddingLeft: 0 }}>
            <input
              type="checkbox"
              name="jumio_optin"
              id="jumio_optin_input"
              required={true}
              checked={this.state.hasOptInt}
              onChange={this.onChangeOptIn.bind(this)}
              style={{ marginTop: '0.2em' }}
            />
            <label
              className="Field__label Field__label--checkbox"
              htmlFor="jumio_optin_input"
            >
              <TranslatedMessage
                id={m.LABEL_JUMIO_OPTIN}
                values={{
                  jumio_optin_privacy_policy_link: this.JumioPrivacyPolicyLink(),
                  jumio_optin_tos_link: this.JumioTOSLink(),
                }}
              />
            </label>
          </p>
        )}
        <br />
        <f.Submit
          className={classNames('IdUpload__Button', {
            disabled: this.formInvalid() || this.state.isSubmitting,
          })}
          isSubmitting={this.state.isSubmitting}
        >
          <TranslatedMessage
            id={
              this.formInvalid()
                ? m.ID_UPLOAD_OPT_IN_REQUIRED
                : m.ID_UPLOAD_UPLOAD
            }
          />
        </f.Submit>
      </form>
    );
  }
}

export default injectIntl(JumioStartForm);
